import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzLabelInput',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    inputSuffix: { default: undefined },
    inputDescriptor: { default: undefined },
    inputDescriptorId: { default: undefined }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})